"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ProductNameInput = void 0;
var _react = require("react");
var _reactHookForm = require("react-hook-form");
var _app = require("../../../../constants/app");
var _useTranslations = require("../../../../hooks/useTranslations");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const ProductNameInput = ()=>{
    const { register, formState: { errors } } = (0, _reactHookForm.useFormContext)();
    const { translations } = (0, _useTranslations.useTranslations)();
    const inputProps = (0, _react.useMemo)(()=>({
            [_app.DATA_TEST_ID]: _constants.PRODUCT_NAME_INPUT
        }), []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.NameInput, {
        ...register('name'),
        variant: "standard",
        error: Boolean(errors.name),
        label: translations.listNameTitle,
        placeholder: translations.listNameDescription,
        inputProps: inputProps
    });
};
exports.ProductNameInput = ProductNameInput;
